import { accountContract as s } from "@hprofits/api/account";
import { adGroupContract as p } from "@hprofits/api/ad-group";
import { adUnitContract as m } from "@hprofits/api/ad-unit";
import { arbitrageModelRuleContract as l } from "@hprofits/api/arbitrage-model-rule";
import { authContract as u } from "@hprofits/api/auth";
import { blacklistAutoRuleContract as f } from "@hprofits/api/blacklist-auto-rule";
import { campaignContract as g } from "@hprofits/api/campaign";
import { creativeGroupContract as d } from "@hprofits/api/creative-group";
import { dictionaryContract as C } from "@hprofits/api/dictionary";
import { domainsContract as R } from "@hprofits/api/domains";
import { goalContract as G } from "@hprofits/api/goal/contract";
import { rotatorCampaignContract as w } from "@hprofits/api/rotator-campaign/contract";
import { statisticsContract as b } from "@hprofits/api/statistics";
import { targetGroupContract as h } from "@hprofits/api/target-group";
import { createORPCClient as v } from "@orpc/client";
import { RequestValidationPlugin as k, ResponseValidationPlugin as y } from "@orpc/contract/plugins";
import { OpenAPILink as A } from "@orpc/openapi-client/fetch";
import { ErrorNormalizationPlugin as P } from "./plugins/error-normalization/error-normalization.js";
import { toTransportError as E } from "./to-transport-error.js";
const a = {
  ...s,
  ...p,
  ...m,
  ...l,
  ...u,
  ...f,
  ...g,
  ...d,
  ...R,
  ...C,
  ...G,
  ...w,
  ...b,
  ...h
}, M = async (r) => r ? typeof r == "function" ? r() : r : {}, W = (r) => {
  const e = async (i, n) => {
    try {
      return await (r.fetch ?? globalThis.fetch)(i, n);
    } catch (o) {
      throw o instanceof Error || o instanceof DOMException ? E(o, i, n) : o;
    }
  }, c = new A(a, {
    url: r.baseURL,
    headers: () => M(r.headers),
    fetch: e,
    plugins: [
      new P(),
      new k(a),
      new y(a)
    ]
  }), t = v(c);
  return {
    account: t.account,
    adGroup: t.adGroup,
    adUnit: t.adUnit,
    asset: t.asset,
    session: t.session,
    profile: t.profile,
    captcha: t.captcha,
    registration: t.registration,
    passwordReset: t.passwordReset,
    token: t.token,
    campaign: t.campaign,
    creativeGroup: t.creativeGroup,
    creatives: t.creatives,
    landings: t.landings,
    landingGroups: t.landingGroups,
    review: t.review,
    domains: t.domains,
    pricingRule: t.pricingRule,
    dictionary: t.dictionary,
    goal: t.goal,
    rotatorCampaign: t.rotatorCampaign,
    statistics: t.statistics,
    targetGroup: t.targetGroup,
    blacklistAutoRule: t.blacklistAutoRule,
    arbitrageModelRule: t.arbitrageModelRule
  };
};
export {
  W as createApiClient
};
//# sourceMappingURL=client.js.map
